import React, { useEffect, useState } from 'react';
import classes from './Experience.module.css';
import ScrollDown from '../UI/ScrollDownIndicator/ScrollDown';
import Tilt from 'react-parallax-tilt';
import Header from '../UI/Header/Header';
import useScreenType from 'react-screentype-hook';
import { ExperiencesData } from '../../Assets/Data/ExperiencesData';
import ExperiencesShapes from '../UI/Shapes/ExperiencesShapes';
import Canvas from '../Canvas/Canvas';
import AOS from 'aos';
import 'aos/dist/aos.css';

const Experience = () => {
  const [expData, setExpData] = useState(
    ExperiencesData.filter(el => {
      return el.year === '2021-22';
    })
  );
  const sortExp = condition => {
    const newData = ExperiencesData.filter(el => {
      return el.year === condition;
    });
    setExpData(newData);
    // console.log(condition, expData);
  };
  useEffect(() => {
    AOS.init({
      // once: true,
      duration: 1000
    });
    // console.log(expData);
  });

  const screenType = useScreenType();
  return (
    <>
      <section className={classes.experience}>
        <Canvas />
        <Header header="EXPERIENCE" />

        <ScrollDown link="#experience" />
      </section>
      {ExperiencesShapes()}
      <section className={classes.experience_section} id="experience">
        <h1 className={classes.experience_text2}>
          <Header header="EXPERIENCES" styles={classes.experience_text2} />
        </h1>
        <div
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: '40px'
          }}
        >
          <button className={classes.button} onClick={() => sortExp('2021-22')}>
            2021-22
          </button>
          <button className={classes.button} onClick={() => sortExp('2022-23')}>
            2022-23
          </button>
          <button className={classes.button} onClick={() => sortExp('2023-24')}>
            2023-24
          </button>
        </div>
        <div className={classes.timeline}>
          {expData.map((e, i) => {
            return e.align === 0 ? (
              <div
                data-aos={'zoom-in-right'}
                key={i}
                className={`${classes.container} ${classes.left}`}
              >
                <div className={classes.date}>{e.date}</div>
                <div className={classes.icon}>
                  <img className={classes.image} src={e.image} alt="" />
                </div>
                <Tilt
                  tiltMaxAngleX={10}
                  tiltMaxAngleY={10}
                  perspective={800}
                  glareColor="#fff"
                  glareEnable={true}
                  glareMaxOpacity={0.3}
                  glareBorderRadius="20px 0 20px 20px"
                  glarePosition="all"
                  scale={screenType.isMobile ? 1 : 1.4}
                >
                  <div
                    className={classes.content}
                    style={{ background: e.color }}
                  >
                    <h3 style={{ color: 'white' }}>{e.company}</h3>
                    <h2 style={{ color: '#ffffffcc' }}>{e.position}</h2>
                    <p>{e.description}</p>
                  </div>
                </Tilt>
              </div>
            ) : (
              <div
                data-aos={'zoom-in-left'}
                key={i}
                className={`${classes.container} ${classes.right}`}
              >
                <div className={classes.date}>{e.date}</div>
                <div className={classes.icon}>
                  <img className={classes.image} src={e.image} alt="" />
                </div>
                <Tilt
                  tiltMaxAngleX={10}
                  tiltMaxAngleY={10}
                  perspective={800}
                  glareColor="#fff"
                  glareEnable={true}
                  glareMaxOpacity={0.3}
                  glareBorderRadius="0 20px 20px 20px"
                  glarePosition="all"
                  scale={screenType.isMobile ? 1 : 1.4}
                >
                  <div
                    className={classes.content}
                    style={{ background: e.color }}
                  >
                    <h3 style={{ color: 'white' }}>{e.company}</h3>
                    <h2 style={{ color: '#ffffffcc' }}>{e.position}</h2>
                    <p>{e.description}</p>
                  </div>
                </Tilt>
              </div>
            );
          })}
          {expData.length === 0 && (
            <h1>
              It is too early to check this experience. Come back next Year to
              check this.
            </h1>
          )}
        </div>
      </section>
    </>
  );
};

export default Experience;
